import { connect } from "react-redux";
import AttendanceDetails from "./attendanceDetails";
import { bindActionCreators } from "redux";
import {
  employeeAttendanceData,
  employeeCheckOutData,
  getAttendanceLocationType,
  getAttendanceOfficeList,
  getAttendanceSiteList,
} from "services/redux/sales/attendance/action";
import { getProfile } from 'services/redux/auth/login/action';

const mapStateToProps = (state) => {
  const userProfileData = state.loginReducer.userProfile;
  const attValSource =
    userProfileData?.attVal ||
    userProfileData?.att_val ||
    [];

  return {
    attendanceData: state.attendanceReducer.attendanceData,
    attendanceOfficeList: state.attendanceReducer.attendanceOfficeList,
    attendanceSiteList: state.attendanceReducer.attendanceSiteList,
    userProfile: attValSource,
    isJourneyStarted: !!userProfileData?.is_journey_started,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAttendanceLocationType,
      getAttendanceOfficeList,
      getAttendanceSiteList,
      employeeAttendanceData,
      employeeCheckOutData,
      getProfile,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceDetails);
